import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AOSProvider = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const hasAos = document.querySelector("[data-aos]");
    if (hasAos) {
      Promise.all([import("aos"), import("aos/dist/aos.css")]).then(
        ([AOSModule]) => {
          const AOS = AOSModule.default || AOSModule;
          AOS.init({
            duration: 800,
            easing: "ease-in-out",
          });
          AOS.refresh();
        }
      );
    }
  }, [location.pathname]);

  return children;
};

export default AOSProvider;
